<div class="input-container">
  <textarea
    #textInput
    type="text"
    [(ngModel)]="textField.text"
    autofocus
    rows="2"
  ></textarea>

  <i
    (click)="isControlsActive = !isControlsActive"
    inlineSVG="/assets/icons/more.svg"
    [removeSVGAttributes]="['style', 'fill']"
    class="toggle-controls-btn"
    [class.active]="isControlsActive"
  ></i>
</div>

<div class="text-controls" *ngIf="isControlsActive">
  <div class="text-controls-header">
    <icn-segment>
      <icn-segment [(value)]="activeControl">
        <icn-segment-button
          [value]="'dynamic'"
          [icon]="'/assets/icons/dynamic-icon.svg'"
          (icnClick)="textInput.focus()"
        >
        </icn-segment-button>
        <icn-segment-button
          [value]="'font'"
          [icon]="'/assets/icons/font-icon.svg'"
        >
        </icn-segment-button>
        <icn-segment-button
          [value]="'link'"
          [icon]="'/assets/icons/link-icon.svg'"
        >
        </icn-segment-button>

        <icn-segment-button
          [value]="'ticker'"
          [icon]="'/assets/icons/ticker-icon.svg'"
        >
        </icn-segment-button>
      </icn-segment>
    </icn-segment>
  </div>

  <div *ngIf="activeControl === 'link'" class="control">
    <icn-graphics-text-link [(link)]="textField.link"></icn-graphics-text-link>
  </div>

  <div *ngIf="activeControl === 'font'" class="control">
    <icn-graphics-text-font
      [(fontId)]="textField.fontId"
      [(size)]="textField.size"
      [(color)]="textField.color"
      [(align)]="textField.align"
      [(shrinkToFit)]="textField.shrinkToFit"
    >
    </icn-graphics-text-font>
  </div>

  <div *ngIf="activeControl === 'dynamic'" class="control">
    <icn-text-dynamic-options
      type="text"
      [isDynamicPromoGraphicInstance]="isDynamicPromoGraphicInstance"
      (dynamicOptionClick)="insertDynamicField($event)"
    >
    </icn-text-dynamic-options>
  </div>

  <div *ngIf="activeControl === 'ticker'" class="control">
    <icn-graphics-text-ticker
      [(isTicker)]="textField.isTicker"
      [(tickerSpeed)]="textField.tickerSpeed"
      [(tickerDirection)]="textField.tickerDirection"
      [(tickerIsLoop)]="textField.tickerIsLoop"
    ></icn-graphics-text-ticker>
  </div>
</div>
